document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.qty-break-option').forEach(item => {
    item.addEventListener('click', event => {
      // Remove selected class from others
      document.querySelectorAll('.qty-break-option').forEach(i => i.classList.remove('selected'));
      
      // Add to current
      item.classList.add('selected');
      
      // Update the actual Shopify quantity input
      const qtyInput = document.querySelector('quantity-selector-component input');
      if (qtyInput) {
        qtyInput.value = parseInt(item.getAttribute('data-qty'));
      }

      /*document.querySelectorAll('input.gfbFrequentBoughtQuanityBox').forEach(i => {
        i.value = parseInt(item.getAttribute('data-qty'));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });*/
    });
  });
});

window.addEventListener('load', function() {
  /*const moveAvisBlock = () => {
    const avisBlock = document.querySelector('.product-information__grid .buy-buttons-block .avisbls-container');
    const productForm = document.querySelector('product-form-component form');
    if (!avisBlock || !productForm) return false;
    // Move original node into the form
    productForm.appendChild(avisBlock);
    avisBlock.classList.add('show');
    return true;
  };
  if (!moveAvisBlock()) {
    const observer = new MutationObserver(() => {
      if (moveAvisBlock()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  moveAvisBlock();

  const updateBundlerPrices = (scope) => {
    scope.querySelectorAll('.bndlr-money').forEach((money) => {
      if (Shopify.locale !== 'hu') {
        money.textContent = money.textContent.replace('{{cart.currency.symbol}}', Theme.currency.symbol);
      } else {
        money.textContent = money.textContent.replace(',00', '');
      }
    });
  };

  const translations = {
    'sk': {
      'Mennyiség:': 'Množstvo:',
      '1 darab': '1 kus',
      '3 darab': '3 kusy',
      'Normál ár': 'Štandardná cena',
      '3980 Ft / darab': '7,99 {{cart.currency.symbol}} / jednotka',
      'Vigyél 3-at, 2 áráért!': 'Kúpte 3 za cenu 2!',
      '1 csomag': '1 balenie',
      '2 csomag': '2 balenie',
      '3 csomag': '3 balenie',
      '6 csomag': '6 balenie',
      '12 csomag': '12 balenie',
      '-1 000 Ft / csomag': '10% zľava',
      '- 1 000 Ft / csomag': '10% zľava',
      '-1 500 Ft / csomag': '20 % zľava + doprava zdarma',
      '- 1 500 Ft / csomag': '20 % zľava + doprava zdarma',
      '30 tapasz - 200 Ft / db': '30 náplastí - 0.43 € / jednotka',
      '60 tapasz - 166 Ft / db': '60 náplastí - 0.39 € / jednotka',
      '90 tapasz - 150 Ft / db': '90 náplastí - 0.34 € / jednotka',
      '4 orrpánt, 15 pár orrtapasz': '4 nosové držiaky, 15 párov nosových pásikov',
      '30 pár tapasz - 216 Ft / pár': '30 párov pásikov – 0,5 € / párov',
      '90 pár tapasz - 194 Ft / pár': '90 párov nosových pásikov - 0,45 € / pár',
      '180 pár tapasz - 172 Ft / pár': '180 párov nosových pásikov - 0,40 € / pár',
      '360 pár tapasz - 150 Ft / pár': '360 párov nosových pásikov - 0,35 € / pár',
      '10%-kal kedvezőbb egységár': 'O 10% výhodnejšia jednotková cena',
      '20%-kal kedvezőbb egységár': 'O 20% výhodnejšia jednotková cena',
      '30%-kal kedvezőbb egységár': 'O 30% výhodnejšia jednotková cena',
      '33%-kal kedvezőbb egységár': 'O 33% výhodnejšia jednotková cena',
      '40%-kal kedvezőbb egységár': 'O 40% výhodnejšia jednotková cena',
      '1+1 csomag': '1+1 balenie',
      '2+2 csomag': '2+2 balenie',
      '3+3 csomag': '3+3 balenie',
      '6+6 csomag': '6+6 balenie',
      '12+12 csomag': '12+12 balenie',
      '30+30 tapasz - 166 Ft / db': '30+30 náplastí - 0,39 € / jednotka',
      '60+60 tapasz - 144 Ft / db': '60+60 náplastí - 0,31 € / jednotka',
      '90+90 tapasz - 130 Ft / db': '90+90 náplastí - 0,27 € / jednotka',
      '180+180 tapasz - 116 Ft / db': '180+180 náplastí - 0,27 € / jednotka',
      '360+360 tapasz - 102 Ft / db': '360+360 náplastí - 0,23 € / jednotka',

    }
  };

  const tryShowBundlerBreaks = () => {
    const breaks = document.querySelector('.bundler-quantity-breaks') || document.querySelector('.bndlr-quantity-break');
    if (!breaks) return false;

    const moneyLabels = breaks.querySelectorAll('.bndlr-money');
    const hasReadyLabels = moneyLabels.length > 0 &&
      Array.from(moneyLabels).some((label) => (label.textContent || '').trim() !== '');
    if (!hasReadyLabels) return false;

    updateBundlerPrices(breaks);

    if (Shopify.locale.toLowerCase() !== 'hu') {
      const elements = Array.from(breaks.querySelectorAll('*'));
      elements.forEach((element) => {
        element.childNodes.forEach((node) => {
          if (node.nodeType !== Node.TEXT_NODE) return;
          const originalText = node.nodeValue || '';
          const trimmedText = originalText.trim();
          if (!trimmedText || !translations[Shopify.locale.toLowerCase()][trimmedText]) return;

          const translatedText = translations[Shopify.locale.toLowerCase()][trimmedText].replace('{{cart.currency.symbol}}', Theme.currency.symbol);
          node.nodeValue = originalText.replace(trimmedText, translatedText);
        });
      });
    }

    breaks.classList.add('show');
    return true;
  };

  if (!tryShowBundlerBreaks()) {
    const observer = new MutationObserver(() => {
      if (!tryShowBundlerBreaks()) return;
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }*/

    /*document.querySelectorAll('.jm-histogram-row').forEach(row => {
        row.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            console.log('row clicked');
        });
    });

    document.querySelectorAll('.jdgm-masonry-grid__masonry-item').forEach(row => {
        row.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            console.log('masonry item clicked');
        });
    });*/

    /*document.querySelectorAll('.jdgm-review-card__content').forEach(row => {
        row.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            console.log('review card clicked');
        });
    });*/

    const customHeroSectionReviewButton = document.querySelector('.custom-review-text-wrap');
    if(customHeroSectionReviewButton) {
      customHeroSectionReviewButton.style.cursor = 'pointer';
      customHeroSectionReviewButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const jdgmHorizonWidget = document.querySelector('.shopify-app-block.jdgm-horizon-widget .jdgm-all-reviews-widget-v2025')?.closest('.shopify-section');
        if(jdgmHorizonWidget) {
          window.scrollTo({ top: jdgmHorizonWidget.getBoundingClientRect().top + window.pageYOffset - document.querySelector('header').getBoundingClientRect().height, behavior: 'smooth' });
        }
      });
    }



    const lang = document.documentElement.lang;

  //ÁSZF
  if(document.getElementById('gendoc_aszf') !== null) {
    fetch("https://admin.fogyasztobarat.hu/api.php?aszf=89IYUM6Y")
      .then(response => response.text())
      .then(ret => {
        const aszfDiv = document.getElementById("gendoc_aszf");
        if (aszfDiv) {
          aszfDiv.innerHTML = ret;
        }

        const hash = window.location.hash.substring(1);
        const targetElement = document.getElementById(hash);

        if (hash && targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      })
      .catch(err => console.warn('Request failed:', err));
  }
  //Privacy policy
  if(document.getElementById('gendoc_at') !== null) {
    fetch("https://admin.fogyasztobarat.hu/api.php?at=89IYUM6Y")
    .then(response => response.text())
    .then(ret => {
      // Update the 'at' specific container
      const atDiv = document.getElementById("gendoc_at");
      if (atDiv) {
        atDiv.innerHTML = ret;
      }

      // Handle the hash scrolling
      const hash = window.location.hash.substring(1);
      const target = document.getElementById(hash);

      if (hash && target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    })
    .catch(err => console.error('Fetch error:', err));
  }
  //Impressum
  if(document.getElementById('gendoc_em') !== null) {
    fetch("https://admin.fogyasztobarat.hu/api.php?em=89IYUM6Y")
    .then(response => response.text())
    .then(ret => {
      // Target the 'em' specific div
      const emDiv = document.querySelector("div#gendoc_em");
      if (emDiv) {
        emDiv.innerHTML = ret;
      }

      // Handle the smooth scroll for anchor links
      const hash = window.location.hash.substring(1); // More reliable than split("#")
      const targetElement = document.getElementById(hash);

      if (hash && targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    })
    .catch(err => console.warn('Request failed', err));
  }
  //Cookie
  if(document.getElementById('gendoc_cookie') !== null) {
    fetch("https://admin.fogyasztobarat.hu/api.php?cookie=89IYUM6Y")
    .then(response => response.text())
    .then(ret => {
      const cookieDiv = document.querySelector("div#gendoc_cookie");
      if (cookieDiv) {
        cookieDiv.innerHTML = ret;
      }

      const sl = window.location.href.split("#");
      const targetId = sl[1];
      const targetElement = document.getElementById(targetId);

      if (targetId && targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    })
    .catch(err => console.error('Error fetching cookie data:', err));
  }
});

const updateStickyMedia = () => {
    const productMedia = document.querySelector('.product-information__media');
    const header = document.querySelector('#header-component');
    const mediaGallery = document.querySelector('media-gallery');

    if (!productMedia || !header) return;

    if (window.innerWidth >= 768) { 
      if(document.querySelector('header-component').dataset.stickyState === 'active') {
        mediaGallery.style.paddingBlock = '0px'
      } else {
        mediaGallery.style.paddingBlock = ''
      }
        productMedia.style.position = 'sticky';
        productMedia.style.alignSelf = 'start';
        // Add header height + 24px gap if header is sticky
        productMedia.style.top = (header.dataset.stickyState === 'active' ? header.offsetHeight + 24 : 24) + 'px';
        productMedia.style.paddingTop = ''; // Remove old padding
    } else {
        // Reset on mobile
        mediaGallery.style.paddingBlock = ''
        productMedia.style.position = '';
        productMedia.style.top = '';
        productMedia.style.alignSelf = '';
        productMedia.style.paddingTop = '';
    }
};

window.addEventListener('scroll', updateStickyMedia, { passive: true });
window.addEventListener('resize', updateStickyMedia, { passive: true });
window.addEventListener('DOMContentLoaded', updateStickyMedia);
updateStickyMedia();

class CartRecommendations extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
        // Use requestAnimationFrame to ensure child elements are parsed
        // both on initial page load and after AJAX innerHTML updates
        requestAnimationFrame(() => {
            this.init();
        });
    }

    init() {
        this.addEventListener('click', this.handleClick);
        window.addEventListener('resize', this.handleResize, { passive: true });
        
        this.observer = new MutationObserver(() => {
            this.attachViewportScroll();
            this.updateArrows();
        });
        this.observer.observe(this, { childList: true, subtree: true });
        
        if (window.ResizeObserver) {
            this.resizeObserver = new ResizeObserver(() => {
                this.updateArrows();
            });
            this.resizeObserver.observe(this);
        }
        
        this.attachViewportScroll();
        this.updateArrows();
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('resize', this.handleResize);
        if (this.viewport) {
            this.viewport.removeEventListener('scroll', this.handleScroll);
        }
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    attachViewportScroll() {
        const newViewport = this.querySelector('.cdr-recs__viewport');
        if (this.viewport !== newViewport) {
            if (this.viewport) {
                this.viewport.removeEventListener('scroll', this.handleScroll);
            }
            this.viewport = newViewport;
            if (this.viewport) {
                this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
            }
        }
    }

    handleClick(e) {
        const prevBtn = e.target.closest('[data-cdr-recs-prev]');
        const nextBtn = e.target.closest('[data-cdr-recs-next]');
        
        if (prevBtn) this.scrollPrev();
        if (nextBtn) this.scrollNext();
    }

    handleScroll() {
        this.updateArrows();
    }

    handleResize() {
        this.updateArrows();
    }

    getStep() {
        if (!this.viewport) return 0;
        const items = this.viewport.querySelectorAll('.cdr-recs__item');
        if (!items.length) return this.viewport.clientWidth;
        
        if (items.length >= 2) {
            return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
        }
        
        const firstCard = items[0];
        const track = this.viewport.querySelector('.cdr-recs__track');
        let gap = 0;
        if (track) {
            const trackStyles = window.getComputedStyle(track);
            gap = parseFloat(trackStyles.gap) || 0;
        }

        const firstStyles = window.getComputedStyle(firstCard);
        const marginLeft = parseFloat(firstStyles.marginLeft) || 0;
        const marginRight = parseFloat(firstStyles.marginRight) || 0;
        return firstCard.getBoundingClientRect().width + marginLeft + marginRight + gap;
    }

    updateArrows() {
        const prevBtn = this.querySelector('[data-cdr-recs-prev]');
        const nextBtn = this.querySelector('[data-cdr-recs-next]');
        
        if (!this.viewport || !prevBtn || !nextBtn) return;
        
        // Prevent disabling arrows when the drawer is hidden (display: none)
        if (this.viewport.clientWidth === 0) return;

        const maxScrollLeft = this.viewport.scrollWidth - this.viewport.clientWidth;
        
        if (maxScrollLeft <= 0) {
            prevBtn.disabled = true;
            nextBtn.disabled = true;
            return;
        }

        prevBtn.disabled = this.viewport.scrollLeft <= 2;
        nextBtn.disabled = Math.ceil(this.viewport.scrollLeft) >= Math.floor(maxScrollLeft) - 2;
    }

    scrollPrev() {
        if (!this.viewport) return;
        this.viewport.scrollBy({ left: -this.getStep(), behavior: 'smooth' });
    }

    scrollNext() {
        if (!this.viewport) return;
        this.viewport.scrollBy({ left: this.getStep(), behavior: 'smooth' });
    }
}

if (!customElements.get('cart-recommendations')) {
    customElements.define('cart-recommendations', CartRecommendations);
}

/* Cross-sell add-to-cart: block double submits while the request is in flight */
(function () {
  const SELECTOR = '.cdr-recs__add, .crp-add';
  const BUSY_TIMEOUT = 10000;
  const busyButtons = new Set();

  function clearBusy(button) {
    button.removeAttribute('aria-busy');
    busyButtons.delete(button);
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const button = form.querySelector(SELECTOR);
      if (!button) return;

      if (button.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      button.setAttribute('aria-busy', 'true');
      busyButtons.add(button);
      setTimeout(() => clearBusy(button), BUSY_TIMEOUT);
    },
    true
  );

  const releaseAll = () => busyButtons.forEach(clearBusy);
  document.addEventListener('cart:update', releaseAll);
  document.addEventListener('cart:error', releaseAll);
})();
